// extracted by mini-css-extract-plugin
export default {"autoLogout":"AutoLogout_autoLogout__srM61","buttons":"AutoLogout_buttons__8zdam"};